import React, { useState, useEffect } from 'react';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import Pagination from '../Common/Pagination';


const DataHistory = () => {

    const { readData: readDataHistoryObjects } = useEntityCrud('Report/DataHistoryObjects');
    const { readData: readDataHistoryReports } = useEntityCrud('Report/DataHistoryReport');

    const [historyObjects, setHistoryObjects] = useState([]);
    const [historyObjectsItem, setHistoryObjectsItem] = useState(null);

    const [historyReport, setHistoryReport] = useState([]);
    const [historyReportTH, setHistoryReportTH] = useState([]);

    const [count, setCount] = useState(0);
    const [isSearched, setIsSearched] = useState(false);

    const [isAdvanced, setIsAdvanced] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showItem, setShowItem] = useState(true);

    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        readDataHistoryObjects().then(({ data }) => {
            setHistoryObjects(data.result.v_result.map(item => ({ value: item.object_name, label: item.object_name })))
        })
    }, [])


    const getData = (postedData) => {

        readDataHistoryReports({ ...postedData }).then((response) => {
            setLoading(false)
            const data = response.data.result.result_use
            const dataCount = response.data.result.v_count

            const itHistoryReport = data.map(item => JSON.parse(item.recordvalue))
            setHistoryReport((itHistoryReport.map(item => Object.values(item))))
            setHistoryReportTH(Object.keys(itHistoryReport.map(item => item)[0]))

            setCount(dataCount.map(item => item.cnt_total));
            calcPages(dataCount.map(item => item.cnt_total)[0]);

        })

    }


    const handleDataHistoryReport = () => {
        setLoading(true)
        setIsAdvanced(true)
        const postedData = {
            "p_entityname": historyObjectsItem,
            "p_offset": 1,
            "p_limit": 10
        }
        setCurrentPage(1)
        getData(postedData);
    }

    const resetDataHistoryReport = (e) => {
        setIsAdvanced(false)
        setHistoryReport([])
        setHistoryReportTH([])
        setHistoryObjectsItem(null)

    }


    const calcPages = data => {
        let calcPages = data / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            "p_entityname": historyObjectsItem,
            "p_limit": 10,
            "p_offset": page
        };
        getData(postedData)
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            "p_entityname": historyObjectsItem,
            "p_limit": 10,
            "p_offset": currentPage - 1
        };
        getData(postedData);
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            "p_entityname": historyObjectsItem,
            "p_limit": 10,
            "p_offset": currentPage + 1
        };
        getData(postedData);
    }




    return (
        <div className="row">
            <div className="col-md-3">
                <div className="form-group">
                    <label> موارد گزارشات </label>
                    <ReactSelect value={historyObjects.filter(b => b.value == historyObjectsItem)}
                        noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید"
                        options={historyObjects} onChange={e => setHistoryObjectsItem(e.value)} />
                </div>
            </div>

            <div className="py-2 col-md-2" style={{ marginTop: 25, textAlign: "center" }}>
                {showItem && <> <button disabled={historyObjectsItem ? false : true} className="btn btn-primary" onClick={() => handleDataHistoryReport()} >جستجو</button>
                    {isAdvanced &&
                        <button className="btn btn-danger mx-2" onClick={() => resetDataHistoryReport()}  >حذف فیلتر</button>
                    }
                </>
                }
            </div>

            {isLoading ?
                <div className="lds-facebook mt-4">
                    <div></div>
                    <div></div>
                    <div></div>
                </div > :

                <>
                    {historyReport.length ? <div className="col-md-12 mt-3">
                        <div className="table-responsive bg-white p-4" style={{ borderRadius: 7 }}>
                            <table className="table custom-table-style table-bordered table-hover mb4">
                                <thead className="table-primary text-center">
                                    <tr>
                                        {historyReportTH.map(item => <th>{item}</th>)}
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {historyReport.map((row) => (
                                        <tr>
                                            {row.map(item => <th>{item}</th>)}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <span>تعداد کل رکورد ها : {count}</span>
                            <div className="d-flex justify-content-between">
                                <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} />
                            </div>
                        </div>
                    </div> : isSearched ? <div className="col-md-12 mt-2"><div className="alert alert-primary"><p>داده ای جهت نمایش یافت نشد</p></div></div> : <div className="col-md-12 mt-2"><div className="alert alert-info"><p
                    >
                        جهت دریافت اطلاعات   لطفا مشخص کنید تاریخچه گزارشات بر چه اساسی باشند.
                    </p></div></div>
                    }
                </>
            }
        </div >
    );
}

export default DataHistory;